import httpClient from '@xver/libs/axios';

import { GetResponseModel } from './model';

const ENDPOINTS = {
    GET_DASHBOARD: '/v1/overview/dashboard',
};

export function getDashboard(): Promise<GetResponseModel> {
    return httpClient.get(ENDPOINTS.GET_DASHBOARD);
}
